import React from "react";
import { SlidersHorizontal } from "lucide-react";
import "./sidebar.css";

// This component accepts the current filter state and a function to update it
export default function Sidebar({ filters, onFilterChange }) {
  
  // Helper to handle simple changes
  const handleChange = (key, value) => {
    onFilterChange(key, value);
  };

  // Helper for toggle arrays (Type, Amenities)
  const handleToggle = (key, item) => {
    const currentList = filters[key] || [];
    const newList = currentList.includes(item)
      ? currentList.filter((i) => i !== item)
      : [...currentList, item];
    onFilterChange(key, newList);
  };

  return (
    <aside className="sidebar-component">
      <div className="sidebar-card">
        
        {/* Header */}
        <div className="filter-header">
          <SlidersHorizontal size={18} />
          <span>Filters</span>
        </div>

        {/* 1. Price Filter */}
        <div className="filter-section">
          <h3>Max Budget</h3>
          <input
            type="range"
            min="500"
            max="20000"
            step="500"
            value={filters.maxBudget}
            onChange={(e) => handleChange("maxBudget", Number(e.target.value))}
            className="range-slider"
          />
          <div className="range-value">Up to AED {filters.maxBudget.toLocaleString()}</div>
        </div>

        {/* 2. Rating Filter */}
        <div className="filter-section">
          <h3>Guest Rating</h3>
          {[9, 8].map((score) => (
            <label key={score} className="checkbox-row">
              <input
                type="checkbox"
                checked={filters.rating === String(score)}
                onChange={() => 
                  handleChange("rating", filters.rating === String(score) ? "any" : String(score))
                }
              />
              <span>{score}+ Very Good</span>
            </label>
          ))}
        </div>

        {/* 3. Property Type */}
        <div className="filter-section">
          <h3>Property Type</h3>
          {["apartment", "hotel", "resort"].map((type) => (
            <label key={type} className="checkbox-row">
              <input
                type="checkbox"
                checked={filters.types.includes(type)}
                onChange={() => handleToggle("types", type)}
              />
              <span style={{ textTransform: "capitalize" }}>{type}</span>
            </label>
          ))}
        </div>

        {/* 4. Amenities */}
        <div className="filter-section">
          <h3>Amenities</h3>
          {["Pool", "WiFi", "Parking", "Gym", "Balcony"].map((item) => (
            <label key={item} className="checkbox-row">
              <input
                type="checkbox"
                checked={filters.amenities.includes(item)}
                onChange={() => handleToggle("amenities", item)}
              />
              <span>{item}</span>
            </label>
          ))}
        </div>

      </div>
    </aside>
  );
}